import removeZeroWidthWhiteSpace from './removeZeroWidthWhiteSpace';

/**
 * 유니코드 공백 특수문자를 제거하고 trim 결과를 반환합니다.
 */
export default function removeZeroWidthWhiteSpaceAndTrim(value: string): string {
  return removeZeroWidthWhiteSpace(value).trim();
}
